import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter} from 'react-router-dom';
import {ConfigProvider} from './config';
import {ResourceStringProvider} from './resource/resourceStrings';
//Custom components
import {App} from './App';
import './index.css';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

import 'ag-grid-enterprise';
import {LicenseManager} from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(process.env.REACT_APP_AGGRID_KEY);

if (process.env.REACT_APP_ENABLE_LOGROCKET === 'true') {
    LogRocket.init('isemfn/paylogik');

    setupLogRocketReact(LogRocket);
}

ReactDOM.render(
    <BrowserRouter>
        <ConfigProvider>
            <ResourceStringProvider>
                <App></App>
            </ResourceStringProvider>
        </ConfigProvider>
    </BrowserRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
